import { gql } from '@apollo/client';

export const INSURANCE_REQUIREMENT_FRAGMENT = gql`
  fragment InsuranceRequirementFragment on InsuranceRequirement {
    created
    publicId
    name
    requiredCoverageTypes
    jobCategories {
      edges {
        node {
          className
        }
      }
    }
    coverageRules {
      edges {
        node {
          id
          ruleName
          ruleJson
        }
      }
    }
  }
`;

export const COI_UPLOADER_SESSION_QUERY = gql`
  query CoiUploadSession($coiUploadSession: String!) {
    coiUploadSession(coiUploadSession: $coiUploadSession) {
      name
      description
      accessType
      pageExpiration
      expirationDate
      effectiveDate
      endDate
      insuranceRequirements {
        edges {
          node {
            ...InsuranceRequirementFragment
          }
        }
      }
      additionalInsureds {
        edges {
          node {
            publicId
            name
            address {
              line1
              line2
              line3
              locality
              region
              postalcode
            }
          }
        }
      }
      organization {
        name
        certificateHolderName
        certificateHolderAddress {
          line1
          line2
          line3
          locality
          region
          postalcode
        }
      }
      contractor {
        publicId
        companyName
        unredactedDict
      }
    }
  }
  ${INSURANCE_REQUIREMENT_FRAGMENT}
`;

export const TRACKER_COI_UPLOADER_SESSION_QUERY = gql`
  query TrackerCoiUploadSession($coiUploadSession: String!) {
    trackerCoiUploadSession(coiUploadSession: $coiUploadSession) {
      name
      description
      accessType
      pageExpiration
      expirationDate
      effectiveDate
      endDate
      insuranceRequirements {
        edges {
          node {
            ...InsuranceRequirementFragment
          }
        }
      }
      additionalInsureds {
        edges {
          node {
            publicId
            name
            address {
              line1
              line2
              line3
              locality
              region
              postalcode
            }
          }
        }
      }
      organization {
        name
        certificateHolderName
        certificateHolderAddress {
          line1
          line2
          line3
          locality
          region
          postalcode
        }
      }
    }
  }
  ${INSURANCE_REQUIREMENT_FRAGMENT}
`;
